import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import "./App.css";

import { ServiceProvider } from "./context/ServiceContext";
import LoginUserPage from "./Pages/LoginPages/LoginUserPage";
import ForgotPasswordPage from "./Pages/LoginPages/ForgotPasswordPage";
import Auth2StepsPage from "./Pages/LoginPages/Auth2StepsPage";
import ConfirmAuth2Steps from "./Pages/LoginPages/ConfirmAuth2Steps";
import SignUpForm from "./Pages/LoginPages/SignUpFrom";
import CreditScorePDF from "./Pages/CreditReport/CreditScorePDF";
import AuthWrapper from "./Components/AuthWrapper";
import MainLayout from "./Layouts/MainLayout";
import { ProfileProvider } from "./context/ProfileContext";
import RouteValidate from "./Pages/RouteValidate/RouteValidate";
import Dashboard from "./Pages/DashboardMenu/Dashboard";
import BulkUpload from "./Pages/BulkService/BulkUpload";
import OcrPan from "./Pages/TestAPI/OcrApi/OcrPan";
import OcrAadhar from "./Pages/TestAPI/OcrApi/OcrAadhar";
import MandateReport from "./Pages/AutoDebitMenu/MandateReport";
import CreateMandate from "./Pages/Mandate/CreateMandate";
import BillingInvoice from "./Pages/MyAccount/BillingInvoice";
import AepsSettlement from "./Pages/MyAccount/AepsSettlement";
import ProfileApiUser from "./Pages/MyAccount/ProfileApiUser";
import VanCollectionReport from "./Pages/CollectMenu/VanCollectionReport";
import WhiteListIP from "./Pages/ApiSetting/WhitelistIp";
import WhitelistYourBankAc from "./Pages/MyAccount/WhitelistYourBankAc";
import CommissionCharges from "./Pages/ApiServices/CommissionCharges";
import AddFund from "./Pages/ApiServices/AddFund";
import ApiLink from "./Pages/ApiServices/ApiLink";
import TestAadhar from "./Pages/TestAPI/AadharApi/TestAadhar";
import AadharV2 from "./Pages/TestAPI/AadharApi/AadharV2";
import TestPan from "./Pages/TestAPI/PanApi/TestPan";
import BankPennyTest from "./Pages/TestAPI/BankApi/BankPennyTest";
import VerifyGST from "./Pages/TestAPI/GstApi/VerifyGST";
import MobileToBank from "./Pages/TestAPI/BankApi/MobileToBank";
import MobileToName from "./Pages/TestAPI/PersonalInfoApi/MobileToName";
import MobileToWhatsUp from "./Pages/TestAPI/PersonalInfoApi/MobileToWhatsUp";
import PanToUdyam from "./Pages/TestAPI/PanApi/PanToUdyam";
import MobileToUdyam from "./Pages/TestAPI/UdyamApi/MobileToUdyam";
import MobileCheck from "./Pages/TestAPI/PersonalInfoApi/MobileCheck";
import EmailCheck from "./Pages/TestAPI/PersonalInfoApi/EmailCheck";
import MoblieToUPIBasic from "./Pages/TestAPI/UpiAPi/MoblieToUPIBasic";
import MobileValidationBasic from "./Pages/TestAPI/PersonalInfoApi/MobileValidationBasic";
import MoblieUPILookUpBasic from "./Pages/TestAPI/UpiAPi/MobileUPILookUpBasic";
import MobileUPILookUpAdvance from "./Pages/TestAPI/UpiAPi/MoblieUPILookUpAdvance";
import MobileUPILookUpEnhance from "./Pages/TestAPI/UpiAPi/MoblieUPILookUpEnhance";
import MobileValidationOTP from "./Pages/TestAPI/PersonalInfoApi/MobileValidationOTP";
import StatementAnalyzer from "./Pages/BankStatementAnalyzer/StatementAnalyzer";
import StatementReport from "./Pages/BankStatementAnalyzer/StatementReport";
import DINToContact from "./Pages/TestAPI/DinApi/DINToContact";
import PinCodeVerify from "./Pages/TestAPI/PersonalInfoApi/PinCodeVerify";
import FaceApi from "./Pages/TestAPI/FaceApi/FaceApi";
import FaceLiveness from "./Pages/TestAPI/FaceApi/FaceLiveness";
import RCVerify from "./Pages/TestAPI/RcAPi/RCVerify";
import VehiclRCverify2 from "./Pages/TestAPI/RcAPi/VehiclRCverify2";
import DLVerify from "./Pages/TestAPI/DLApi/DLVerify";
import AadharPankLink from "./Pages/TestAPI/AadharApi/AadharPanLink";
import TestMaster from "./Pages/TestAPI/TestMaster";
import HelpDesk from "./Pages/MyAccount/HelpDesk";
import PrepaidCard from "./Pages/CardMenu/PrepaidCard";
import ExpenseCard from "./Pages/CardMenu/ExpenseCard";
import NewsNotification from "./Pages/DashboardMenu/NewsNotification";
import Crif_EquifaxReport from "./Pages/EquifaxMenu/EquifaxReport/Crif_EquifaxReport";
import TransUnionScore from "./Pages/EquifaxMenu/TransUnionScore/TransUnionScore";
import TransUnionScore2 from "./Pages/EquifaxMenu/TransUnionScore2/TransUnionScore";
import TransUnionScore3 from "./Pages/EquifaxMenu/TransUnionScore3/TransUnionScore";
import EquifaxV2 from "./Pages/CreditReport/EquifaxV2";
import EquifaxCrScorev2 from "./Pages/CreditReport/EquifaxCrScorev2";
import CrifCreditScore from "./Pages/EquifaxMenu/CrifCreditScore/CrifCreditScore";
import CrifCreditScore2 from "./Pages/EquifaxMenu/CrifCreditScore2/CrifCreditScore2";
import ExperianScore from "./Pages/EquifaxMenu/Experian/ExperianScore";
import EquifaxCrScore from "./Pages/EquifaxMenu/EquifaxCrScore/EquifaxCrScore";
import CrifPdfUrl from "./Pages/EquifaxMenu/CrifPdfUrl/CrifPdfUrl";
import EquifaxPdfUrl from "./Pages/EquifaxMenu/EquifaxPdfUrl/EquifaxPdfUrl";
import TransunionPdfUrl from "./Pages/EquifaxMenu/TransunionPdfUrl/TransunionPdfUrl";
import ExperianPdfUrl from "./Pages/EquifaxMenu/ExperianPdfUrl/ExperianPdfUrl";
import MobileToBankBasic from "./Pages/TestAPI/BankApi/MobileToBankBasic";
import MobileToBankAdvance from "./Pages/TestAPI/BankApi/MobileToBankAdvance";
import GstToContact from "./Pages/BulkService/GstBulkUpload";
import BasicCompanyCin from "./Pages/TestAPI/CompanyCinApi/BasicCompanyCin";
import BulkReportAll from "./Pages/BulkService/BulkReportAll";
import PanToCin from "./Pages/TestAPI/PanApi/PanToCin";
import EquifaxCreditReportDashboard from "./Pages/EquifaxMenu/EquifaxCreditReport/EquifaxCreditReportDashboard";
import HighmarkCrScore from "./Pages/EquifaxMenu/HighmarkCrScore/HighmarkCrScore";
import CheckScore from "./Pages/EquifaxMenu/CheckScore/CheckScore";
import CheckScorePrefill from "./Pages/EquifaxMenu/CheckScore/CheckScorePrefill";
import ExperianScore2 from "./Pages/EquifaxMenu/Experian2/ExperianScore";
import ExperianScore3 from "./Pages/EquifaxMenu/Experian3/ExperianScore3";
import CreateMobileDeviceLock from "./Pages/MobileDeviceLock/CreateMobileDeviceLock";
import RcToChallan from "./Pages/TestAPI/RcAPi/RcToChallan";
import AadharDetailsVerify from "./Pages/TestAPI/AadharApi/AadharDetailsVerify";
import BankVerificationPennyDrop from "./Pages/TestAPI/BankApi/BankVerificationPennyDrop";
import BankBennyValidation from "./Pages/TestAPI/BankApi/BankBennyValidation";
import AadharToPanDetails from "./Pages/TestAPI/AadharApi/AadharToPanDetails";
import BusinessWalletStructure from "./Pages/MyAccount/BusinessWalletStructure";
import PayoutReport from "./Pages/PayoutMenu/PayoutReport";
import ServicePage from "./Pages/ApiServices/ServicePage";
import ApiIntegrationGuide from "./Pages/ApiServices/ApiIntegrationGuide";
import DiscriptionLink from "./Pages/ApiServices/DiscriptionLink";
import RechargeAndBBPSReport from "./Pages/RechargeAndBBPS/RechargeAndBBPSReport";
import AadharDownload from "./Pages/TestAPI/AadharApi/AadharDownload";
import CompanyCinVerfication from "./Pages/TestAPI/CompanyCinApi/CompanyCinVerfication";
import ItrComplinceCheck from "./Pages/TestAPI/PersonalInfoApi/ItrComplinceCheck";
import RationCardTest from "./Pages/TestAPI/PersonalInfoApi/RationCardTest";
import AdvanceUpiCheck from "./Pages/TestAPI/UpiAPi/AdvanceUpiCheck";
import BankAccountAnlyscis from "./Pages/TestAPI/BankApi/BankAcciountAnlysics";
import SimpleUpiCheck from "./Pages/TestAPI/UpiAPi/SimpleUpiCheck";
import PanVerificationV2 from "./Pages/TestAPI/PanApi/PanVerficationV2";
import PanVerificationPlus from "./Pages/TestAPI/PanApi/PanVerficationPlus";
import PanVerificationForm from "./Pages/TestAPI/PanApi/PanVerficationForm";
import VoterCardVerificationv2 from "./Pages/TestAPI/PersonalInfoApi/VoterCardVerificationv2";
import PassportCardVerificationv2 from "./Pages/TestAPI/PersonalInfoApi/PassportCardVerificationv2";
import DLVerficationV2 from "./Pages/TestAPI/DLApi/DLverification2";
import DLVerifyPlus from "./Pages/TestAPI/DLApi/DLVerifyPlus";
import AadharDigitalKyc from "./Pages/TestAPI/AadharApi/AadharKyc";
import VerifyRc from "./Pages/TestAPI/RcAPi/VerifyRc";
import VerifyRcReverse from "./Pages/TestAPI/RcAPi/VerifyRcReverse";
import VerifyRcPlus from "./Pages/TestAPI/RcAPi/verifyRCPlus";
import FaceDetection from "./Pages/TestAPI/FaceApi/FaceDetection";
import PanDetailsV1 from "./Pages/TestAPI/PanApi/PanDetailsV1";
import PanToFatherDetails from "./Pages/TestAPI/PanApi/PanToFatherDetails";
import PanBasic from "./Pages/TestAPI/PanApi/PanBasic";
import PanDetailsV2 from "./Pages/TestAPI/PanApi/PanDetailsV2";
import PanProfile from "./Pages/TestAPI/PanApi/PanProfile";
import UdyamBasic from "./Pages/TestAPI/UdyamApi/UdyamBasic";
import MobileToUdyamLookup from "./Pages/TestAPI/UdyamApi/MobileToUdyamLookup";
import UdyamAdvance from "./Pages/TestAPI/UdyamApi/UdyamAdvance";
import RcToMobile from "./Pages/TestAPI/RcAPi/RCToMobile";
import RcVerification from "./Pages/TestAPI/RcAPi/RcVerification";
import RcVerificationAdvance from "./Pages/TestAPI/RcAPi/RcVerificationAdvance";
import BankVerificationPennyDropAdvance from "./Pages/TestAPI/BankApi/BankVerificationPennyDropAdvance";
import BankBennyValidationAdvance from "./Pages/TestAPI/BankApi/BankBennyValidationAdvance";
import IFSCVerify from "./Pages/TestAPI/BankApi/IFSCVerify";
import DinToPan from "./Pages/TestAPI/DinApi/DinToPan";
import PanToDin from "./Pages/TestAPI/PanApi/PanToDin";
import GstPanSearch from "./Pages/TestAPI/GstApi/GstPanSearch";
import DigitalKyc from "./Pages/TestAPI/PersonalInfoApi/DigitalKyc";
import DigilockerResultPage from "./Pages/TestAPI/PersonalInfoApi/DigilockerResultPage";
import DinToContact2 from "./Pages/TestAPI/DinApi/DinToContact2";
import VerifyConsumerDetails from "./Pages/TestAPI/PersonalInfoApi/VerifyConsumerDetails";
import Prefill from "./Pages/TestAPI/PrefillApi/Prefill";
import Prefillv2 from "./Pages/TestAPI/PrefillApi/Prefillv2";
import Prefillv3 from "./Pages/TestAPI/PrefillApi/Prefillv3";
import Prefillv4 from "./Pages/TestAPI/PrefillApi/Prefillv4";
import RcCardDetails from "./Pages/TestAPI/RcAPi/RcCard";
import ProfileFetch from "./Pages/TestAPI/PersonalInfoApi/ProfileFetch";
import OcrVoter from "./Pages/TestAPI/OcrApi/OcrVoter";
import OcrPassport from "./Pages/TestAPI/OcrApi/OcrPassport";
import OcrDl from "./Pages/TestAPI/OcrApi/OcrDl";
import OcrGenericKyc from "./Pages/TestAPI/OcrApi/OcrGenericKyc";
import DrivingLicence from "./Pages/TestAPI/DLApi/DrivingLicence";
import RcVerificationFull from "./Pages/TestAPI/RcAPi/RcVerificationFull";
import UpiVerificationAdvance from "./Pages/TestAPI/UpiAPi/UpiVerificationAdvance";
import UpiVerificationSimple from "./Pages/TestAPI/UpiAPi/UpiVerificationSimple";
import PanToContact from "./Pages/TestAPI/PanApi/PanToContact";
import PanToBankAccount from "./Pages/TestAPI/PanApi/PanToBankAccount";
import Mandate from "./Pages/Mandate/MandateDashboard";
import AppDownload from "./AppDownload";
import VerifyKybBasic from "./Pages/TestAPI/GstApi/VerifyKybBasicGST";
import VerifyKybAdvancedGST from "./Pages/TestAPI/GstApi/VerifyKybAdvancedGST";
import VerifyKybContactToGST from "./Pages/TestAPI/GstApi/VerifyKybContactToGST";
import VerifyKybGSTToContact from "./Pages/TestAPI/GstApi/VerifyKybGsTToContact";
import Ovse from "./Pages/TestAPI/PersonalInfoApi/Ovse";
import SinglePayout from "./Pages/PayoutMenu/SinglePayout";
import ManageBenificiary from "./Pages/PayoutMenu/ManageBenificiary";
import BulkPayout from "./Pages/PayoutMenu/BulkPayout";
import PayoutAllReport from "./Pages/PayoutMenu/PayoutAllReport";
import ChallanPro from "./Pages/TestAPI/RcAPi/ChallanPro";
import FastagBalance from "./Pages/TestAPI/FastagAPi/FastagBalance";
import RcPro from "./Pages/TestAPI/RcAPi/RcPro";
import ChasisToRc from "./Pages/TestAPI/RcAPi/ChasisToRc";
import FastagTxn from "./Pages/TestAPI/FastagAPi/FastagTxn";
import MobileToRC from "./Pages/TestAPI/RcAPi/MobileToRc";
import RcToMobileSrv1 from "./Pages/TestAPI/RcAPi/RcToMobileSrv1";
import VehicleValuationPro from "./Pages/TestAPI/RcAPi/VehicleValuationPro";
import EngineToRc from "./Pages/TestAPI/RcAPi/EngineToRc";
import LockScreen from "./Pages/LoginPages/LockScreen";
import CompleteProfile from "./Pages/DashboardMenu/CompleteProfile";
import SessionExpired from "./Pages/ExpirePage/SessionExpired";
import Loader from "./Loader";
import VehicleRcLite from "./Pages/TestAPI/RcAPi/VehicleRcLite";
import VehicleRcLogs from "./Pages/TestAPI/RcAPi/VehicleRcLogs";
import VehiclePuccPro from "./Pages/TestAPI/RcAPi/VehiclePuccPro";
import VehicleExShowroom from "./Pages/TestAPI/RcAPi/VehicleExShowroom";
import VehicleInsurancePro from "./Pages/TestAPI/RcAPi/VehicleInsurancePro";
import FastagStatus from "./Pages/TestAPI/FastagAPi/FastagStatus";
import VehicleFastagMapper from "./Pages/TestAPI/FastagAPi/VehicleFastagMapper";
import DlLicence from "./Pages/TestAPI/DLApi/DlLicence";
import BasicEChallan from "./Pages/TestAPI/RcAPi/BasicEChallan";
import DownloadingPage from "./Pages/BankStatementAnalyzer/DownloadingPage";
import ExperianV2Pdf from "./Pages/EquifaxMenu/ExperianV2Pdf/ExperianV2Pdf";
import BulkRcToMobile from "./Pages/BulkService/BulkRcToMobile";
import UanMobile from "./Pages/TestAPI/Uan/UanMobile";
import UanNameDob from "./Pages/TestAPI/Uan/UanNameDob";
import UanDirect from "./Pages/TestAPI/Uan/UanDirect";
import UanPan from "./Pages/TestAPI/Uan/UanPan";
import UanMobileSrv3 from "./Pages/TestAPI/Uan/UanMobileSrv3";
import UanDirectSrv3 from "./Pages/TestAPI/Uan/UanDirectSrv3";
import UanPanMobileSrv3 from "./Pages/TestAPI/Uan/UanPanMobileSrv3";
import CreateMandateFirst from "./Pages/AutoDebitMenu/CreateManadate";
import AadhaarToUnmaskedPan from "./Pages/TestAPI/AadharApi/AadhaarToUnmaskedPan";
import CrifCreditScore4 from "./Pages/EquifaxMenu/CrifCreditScore4/CrifCreditScore4";
import BulkPanToContact from "./Pages/BulkService/BulkPanToContact";
import CrifScoreCheck from "./Pages/EquifaxMenu/CrifScoreCheck/CrifScoreCheck";
import VerifyGstBasic from "./Pages/TestAPI/GstApi/VerifyGstBasic";
import ChasisToRcV2 from "./Pages/TestAPI/RcAPi/ChassisToRcV2";
import KycPanDetails from "./Pages/TestAPI/PanApi/KycPanDetails";
import UpiBasicV2 from "./Pages/TestAPI/UpiAPi/UpiBasicV2";
import ChallanProImage from "./Pages/TestAPI/RcAPi/ChallanProImage";
import VehicleServiceHistory from "./Pages/TestAPI/RcAPi/VehicleServiceHistory";
import AadhaarSpecial from "./Pages/TestAPI/AadharApi/AadhaarSpecial";
import PennyDropCheckValidation from "./Pages/TestAPI/BankApi/PennyDropCheckValidation";
import PennyLessCheckValidation from "./Pages/TestAPI/BankApi/PennyLessCheckValidation";
import PennyUpiCheckValidation from "./Pages/TestAPI/BankApi/PennyUpiCheckValidation";
import TransunionHybrid from "./Pages/EquifaxMenu/TransunionHybrid/TransunionHybrid";
import TransunionHybridPdf from "./Pages/EquifaxMenu/TransunionHybrid/TransunionHybridPdf";
import EwayBillV2 from "./Pages/TestAPI/BankApi/EwayBillV2";
import ProfileFetchV2 from "./Pages/TestAPI/PersonalInfoApi/profileFetchV2/ProfileFetchV2";
import MobileToUpiAdvanceSrv2 from "./Pages/TestAPI/UpiAPi/MobileToUpiAdvanceSrv2";
import TransunionHybridPdf2 from "./Pages/EquifaxMenu/TransunionHybrid2/TransunionHybridPdf2";
import CheckFIR from "./Pages/TestAPI/FIR/CheckFir";
import ESigner from "./Pages/TestAPI/Esign/ESigner";
import RcPremiumV2 from "./Pages/TestAPI/RcAPi/RcPremiumV2";
import RcToMobileSrv2 from "./Pages/TestAPI/RcAPi/crois_rc/RcToMobileSrv2";
import MobileToRcSrv2 from "./Pages/TestAPI/RcAPi/crois_rc/MobileToRcSrv2";
import RcProMasked from "./Pages/TestAPI/RcAPi/crois_rc/RcProMasked";
import RcProUnmasked from "./Pages/TestAPI/RcAPi/crois_rc/RcProUnmasked";
import EChallanSrv2 from "./Pages/TestAPI/RcAPi/crois_rc/EChallanSrv2";
import RcProCache from "./Pages/TestAPI/RcAPi/crois_rc/RcProCache";
import ChallanProSrv2 from "./Pages/TestAPI/RcAPi/crois_rc/ChallanProSrv2";
import EngineToRcSrv2 from "./Pages/TestAPI/RcAPi/crois_rc/EngineToRcSrv2";
import ChassisToRcSrv2 from "./Pages/TestAPI/RcAPi/crois_rc/ChassisToRcSrv2";
import VehicleInsurance from "./Pages/TestAPI/RcAPi/crois_rc/VehicleInsurance";
import VehicleFopDetails from "./Pages/TestAPI/RcAPi/crois_rc/VehicleFopDetails";
import MobileToAccountSrv2 from "./Pages/TestAPI/BankApi/MobileToAccountSrv2";
import BankAccountAggregator from "./Pages/TestAPI/BankApi/BankAccountAggregator";
import RcPremiumV3 from "./Pages/TestAPI/RcAPi/crois_rc/RcPremiumV3";
import RcPremiumV4 from "./Pages/TestAPI/RcAPi/crois_rc/RcPremiumV4";

function App() {
  // useInactivityLogout(3600000); // Set the inactivity timeout to 60 minutes
  // 3,600,000 milliseconds = 60 minutes
  // 1 minute = 60,000 milliseconds
  // 3,600,000 ÷ 60,000 = 60

  return (
    <Router>
      <RoutesWrapper>
        <ServiceProvider>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<LoginUserPage />} />
            <Route
              path="/ForgotPasswordPage"
              element={<ForgotPasswordPage />}
            />
            <Route path="/Auth2StepsPage" element={<Auth2StepsPage />} />
            <Route path="/ConfirmAuth2Steps" element={<ConfirmAuth2Steps />} />
            <Route path="/SignUpForm" element={<SignUpForm />} />
            <Route path="/credit-report-pdf" element={<CreditScorePDF />} />
            <Route
              path="/DownloadingPageForStatement"
              element={<DownloadingPage />}
            />

            {/* Protected Routes */}
            <Route
              element={
                <AuthWrapper>
                  <MainLayout />
                </AuthWrapper>
              }
            >
              <Route
                path="/Dashboard"
                element={
                  <ProfileProvider>
                    <RouteValidate slug={"Dashboard"}>
                      <Dashboard />
                    </RouteValidate>
                  </ProfileProvider>
                }
              />

              <Route
                path="/BulkUpload"
                element={
                  <RouteValidate slug={"BulkUpload"}>
                    <BulkUpload />
                  </RouteValidate>
                }
              />
              {/* <Route path="/BulkDownload" element={<RouteValidate slug={'BulkDownload'}><BulkDownload /></RouteValidate>} />  */}

              <Route
                path="/ocr-pan"
                element={
                  <RouteValidate slug={"/ocr-pan"}>
                    <OcrPan />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/ocr-aadhar"
                element={
                  <RouteValidate slug={"/ocr-aadhar"}>
                    <OcrAadhar />
                  </RouteValidate>
                }
              ></Route>

              <Route
                path="/MandateReport"
                element={
                  <RouteValidate slug={"MandateReport"}>
                    <MandateReport />
                  </RouteValidate>
                }
              />
              <Route
                path="/CreateMandate"
                element={
                  <RouteValidate slug={"CreateMandate"}>
                    <CreateMandateFirst />
                  </RouteValidate>
                }
              />
              <Route
                path="/BillingInvoice"
                element={
                  <RouteValidate slug={"BillingInvoice"}>
                    <BillingInvoice />
                  </RouteValidate>
                }
              />
              <Route
                path="/AepsSettlement"
                element={
                  <RouteValidate slug={"AepsSettlement"}>
                    <AepsSettlement />
                  </RouteValidate>
                }
              />
              <Route
                path="/ProfileApiUser"
                element={
                  <RouteValidate slug={"ProfileApiUser"}>
                    <ProfileApiUser />
                  </RouteValidate>
                }
              />
              <Route
                path="/VanCollectionReport"
                element={
                  <RouteValidate slug={"VanCollectionReport"}>
                    {" "}
                    <VanCollectionReport />
                  </RouteValidate>
                }
              />
              <Route
                path="/WhitelistIp"
                element={
                  <RouteValidate slug={"WhitelistIp"}>
                    {" "}
                    <WhiteListIP />
                  </RouteValidate>
                }
              />
              <Route
                path="/WhitelistYourBankAc"
                element={
                  <RouteValidate slug={"WhitelistYourBankAc"}>
                    {" "}
                    <WhitelistYourBankAc />
                  </RouteValidate>
                }
              />
              <Route
                path="/CommissionCharges"
                element={
                  <RouteValidate slug={"CommissionCharges"}>
                    {" "}
                    <CommissionCharges />
                  </RouteValidate>
                }
              />
              <Route
                path="/AddFund"
                element={
                  <RouteValidate slug={"AddFund"}>
                    <AddFund />
                  </RouteValidate>
                }
              />
              <Route
                path="/ApiLink"
                element={
                  <RouteValidate slug={"ApiLink"}>
                    {" "}
                    <ApiLink />
                  </RouteValidate>
                }
              />
              <Route
                path="/TestAadhar"
                element={
                  <RouteValidate slug={"TestAadhar"}>
                    {" "}
                    <TestAadhar />
                  </RouteValidate>
                }
              />
              <Route
                path="/AadharV2"
                element={
                  <RouteValidate slug={"AadharV2"}>
                    {" "}
                    <AadharV2 />
                  </RouteValidate>
                }
              />
              <Route
                path="/AadhaarSpecial"
                element={
                  <RouteValidate slug={"AadhaarSpecial"}>
                    {" "}
                    <AadhaarSpecial />
                  </RouteValidate>
                }
              />
              <Route
                path="/TestPan"
                element={
                  <RouteValidate slug={"TestPan"}>
                    {" "}
                    <TestPan />
                  </RouteValidate>
                }
              />
              <Route
                path="/BankPennyTest"
                element={
                  <RouteValidate slug={"BankPennyTest"}>
                    {" "}
                    <BankPennyTest />
                  </RouteValidate>
                }
              />
              <Route
                path="/PennyDropCheckValidation"
                element={
                  <RouteValidate slug={"PennyDropCheckValidation"}>
                    {" "}
                    <PennyDropCheckValidation />
                  </RouteValidate>
                }
              />
              <Route
                path="/PennyLessCheckValidation"
                element={
                  <RouteValidate slug={"PennyLessCheckValidation"}>
                    {" "}
                    <PennyLessCheckValidation />
                  </RouteValidate>
                }
              />
              <Route
                path="/PennyUpiCheckValidation"
                element={
                  <RouteValidate slug={"PennyUpiCheckValidation"}>
                    {" "}
                    <PennyUpiCheckValidation />
                  </RouteValidate>
                }
              />
              <Route
                path="/VerifyGST"
                element={
                  <RouteValidate slug={"VerifyGST"}>
                    <VerifyGST />
                  </RouteValidate>
                }
              />
              <Route
                path="/MobileToBank"
                element={
                  <RouteValidate slug={"MobileToBank"}>
                    <MobileToBank />
                  </RouteValidate>
                }
              />
              <Route
                path="/MobileToName"
                element={
                  <RouteValidate slug={"MobileToName"}>
                    <MobileToName />
                  </RouteValidate>
                }
              />
              <Route
                path="/MobileToWhatsUp"
                element={
                  <RouteValidate slug={"MobileToWhatsUp"}>
                    <MobileToWhatsUp />
                  </RouteValidate>
                }
              />
              <Route
                path="/PanToUdyam"
                element={
                  <RouteValidate slug={"PanToUdyam"}>
                    <PanToUdyam />
                  </RouteValidate>
                }
              />
              <Route
                path="/MobileToUdyam"
                element={
                  <RouteValidate slug={"MobileToUdyam"}>
                    <MobileToUdyam />
                  </RouteValidate>
                }
              />
              <Route
                path="/MobileCheck"
                element={
                  <RouteValidate slug={"MobileCheck"}>
                    <MobileCheck />
                  </RouteValidate>
                }
              />
              <Route
                path="/EmailCheck"
                element={
                  <RouteValidate slug={"EmailCheck"}>
                    <EmailCheck />
                  </RouteValidate>
                }
              />
              <Route
                path="/MoblieToUPIBasic"
                element={
                  <RouteValidate slug={"MoblieToUPIBasic"}>
                    <MoblieToUPIBasic />
                  </RouteValidate>
                }
              />
              <Route
                path="/MobileValidationBasic"
                element={
                  <RouteValidate slug={"MobileValidationBasic"}>
                    <MobileValidationBasic />
                  </RouteValidate>
                }
              />
              <Route
                path="/MoblieUPILookUpBasic"
                element={
                  <RouteValidate slug={"MoblieUPILookUpBasic"}>
                    <MoblieUPILookUpBasic />
                  </RouteValidate>
                }
              />
              <Route
                path="/MobileUPILookUpAdvance"
                element={
                  <RouteValidate slug={"MobileUPILookUpAdvance"}>
                    <MobileUPILookUpAdvance />{" "}
                  </RouteValidate>
                }
              />
              <Route
                path="/MobileUPILookUpEnhance"
                element={
                  <RouteValidate slug={"MobileUPILookUpEnhance"}>
                    <MobileUPILookUpEnhance />{" "}
                  </RouteValidate>
                }
              />
              <Route
                path="/MobileValidationOTP"
                element={
                  <RouteValidate slug={"MobileValidationOTP"}>
                    <MobileValidationOTP />
                  </RouteValidate>
                }
              />
              <Route
                path="/StatementAnalyzer"
                element={
                  <RouteValidate slug={"StatementAnalyzer"}>
                    <StatementAnalyzer />
                  </RouteValidate>
                }
              />

              <Route
                path="/StatementReport"
                element={
                  <RouteValidate slug={"StatementReport"}>
                    <StatementReport />
                  </RouteValidate>
                }
              />
              <Route
                path="/dintocontact"
                element={
                  <RouteValidate slug="/dintocontact">
                    <DINToContact />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/PinCodeVerify"
                element={
                  <RouteValidate slug={"PinCodeVerify"}>
                    <PinCodeVerify />
                  </RouteValidate>
                }
              />
              <Route
                path="/faceAPI"
                element={
                  <RouteValidate slug="/faceAPI">
                    <FaceApi />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/faceLiveness"
                element={
                  <RouteValidate slug="/faceLiveness">
                    <FaceLiveness />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/RCVerify"
                element={
                  <RouteValidate slug={"RCVerify"}>
                    <RCVerify />
                  </RouteValidate>
                }
              />
              <Route
                path="/VehiclRCverify2"
                element={
                  <RouteValidate slug={"VehiclRCverify2"}>
                    <VehiclRCverify2 />
                  </RouteValidate>
                }
              />
              <Route
                path="/DLVerify"
                element={
                  <RouteValidate slug={"DLVerify"}>
                    <DLVerify />
                  </RouteValidate>
                }
              />
              <Route
                path="/AadharPanLink"
                element={
                  <RouteValidate slug={"AadharPanLink"}>
                    <AadharPankLink />
                  </RouteValidate>
                }
              />
              <Route
                path="/TestMaster"
                element={
                  <RouteValidate slug={"TestMaster"}>
                    <TestMaster />
                  </RouteValidate>
                }
              />
              <Route
                path="/HelpDesk"
                element={
                  <RouteValidate slug={"HelpDesk"}>
                    <HelpDesk />
                  </RouteValidate>
                }
              />
              <Route
                path="/PrepaidCard"
                element={
                  <RouteValidate slug={"PrepaidCard"}>
                    <PrepaidCard />
                  </RouteValidate>
                }
              />
              <Route
                path="/ExpenseCard"
                element={
                  <RouteValidate slug={"ExpenseCard"}>
                    <ExpenseCard />
                  </RouteValidate>
                }
              />
              <Route
                path="/NewsNotification"
                element={
                  <RouteValidate slug={"NewsNotification"}>
                    <NewsNotification />
                  </RouteValidate>
                }
              />
              <Route
                path="/Crif_EquifaxReport"
                element={
                  <RouteValidate slug={"Crif_EquifaxReport"}>
                    <Crif_EquifaxReport />
                  </RouteValidate>
                }
              />
              <Route
                path="/credit-report/transunion"
                element={
                  <RouteValidate slug={"/credit-report/transunion"}>
                    <TransUnionScore />{" "}
                  </RouteValidate>
                }
              />
              <Route
                path="/transunion-hybrid"
                element={
                  <RouteValidate slug={"/transunion-hybrid"}>
                    <TransunionHybrid />{" "}
                  </RouteValidate>
                }
              />
              <Route
                path="/transunion-hybrid-pdf-2"
                element={
                  <RouteValidate slug={"/transunion-hybrid-pdf-2"}>
                    <TransunionHybridPdf2 />{" "}
                  </RouteValidate>
                }
              />
              <Route
                path="/transunion-hybrid-pdf"
                element={
                  <RouteValidate slug={"/transunion-hybrid-pdf"}>
                    <TransunionHybridPdf />{" "}
                  </RouteValidate>
                }
              />
              <Route
                path="/credit-report/transunion2"
                element={
                  <RouteValidate slug={"/credit-report/transunion2"}>
                    <TransUnionScore2 />{" "}
                  </RouteValidate>
                }
              />
              <Route
                path="/credit-report/transunion3"
                element={
                  <RouteValidate slug={"/credit-report/transunion3"}>
                    <TransUnionScore3 />{" "}
                  </RouteValidate>
                }
              />
              <Route
                path="/credit-report/equifax-v2"
                element={
                  <RouteValidate slug={"/credit-report/equifax-v2"}>
                    <EquifaxCrScorev2 />{" "}
                  </RouteValidate>
                }
              />
              <Route
                path="/CrifCreditScore"
                element={
                  <RouteValidate slug={"CrifCreditScore"}>
                    <CrifCreditScore />{" "}
                  </RouteValidate>
                }
              />
              <Route
                path="/CrifCreditScore2"
                element={
                  <RouteValidate slug={"CrifCreditScore2"}>
                    <CrifCreditScore2 />{" "}
                  </RouteValidate>
                }
              />
              <Route
                path="/CrifScoreCheck"
                element={
                  <RouteValidate slug={"CrifScoreCheck"}>
                    <CrifScoreCheck />{" "}
                  </RouteValidate>
                }
              />
              <Route
                path="/CrifCreditScore4"
                element={
                  <RouteValidate slug={"CrifCreditScore4"}>
                    <CrifCreditScore4 />{" "}
                  </RouteValidate>
                }
              />
              <Route
                path="/credit-report/experian"
                element={
                  <RouteValidate slug={"//credit-report/experian"}>
                    <ExperianScore />
                  </RouteValidate>
                }
              />
              <Route
                path="/EquifaxCrScore"
                element={
                  <RouteValidate slug={"EquifaxCrScore"}>
                    <EquifaxCrScore />
                  </RouteValidate>
                }
              />
              <Route
                path="/CrifPdfUrl"
                element={
                  <RouteValidate slug={"CrifPdfUrl"}>
                    <CrifPdfUrl />
                  </RouteValidate>
                }
              />
              <Route
                // path="/CrifPdfUrl"
                path="EquifaxPdfUrl"
                element={
                  <RouteValidate slug={"EquifaxPdfUrl"}>
                    <EquifaxPdfUrl />
                  </RouteValidate>
                }
              />

              <Route
                path="/transunion-pdf"
                element={
                  <RouteValidate slug={"/transunion-pdf"}>
                    <TransunionPdfUrl />{" "}
                  </RouteValidate>
                }
              />

              <Route
                path="/experian-pdf"
                element={
                  <RouteValidate slug={"/experian-pdf"}>
                    <ExperianPdfUrl />{" "}
                  </RouteValidate>
                }
              />

              <Route
                path="/experian-v2-pdf"
                element={
                  <RouteValidate slug={"/experian-v2-pdf"}>
                    <ExperianV2Pdf />{" "}
                  </RouteValidate>
                }
              />

              <Route
                path="/MobileToBankBasic"
                element={
                  <RouteValidate slug={"MobileToBankBasic"}>
                    <MobileToBankBasic />
                  </RouteValidate>
                }
              />
              <Route
                path="/MobileToBankAdvance"
                element={
                  <RouteValidate slug={"MobileToBankAdvance"}>
                    <MobileToBankAdvance />
                  </RouteValidate>
                }
              />

              <Route
                path="/GstBulkUpload"
                element={
                  <RouteValidate slug="GstBulkUpload">
                    <GstToContact />
                  </RouteValidate>
                }
              />
              <Route
                path="/BulkPanToContact"
                element={
                  <RouteValidate slug="BulkPanToContact">
                    <BulkPanToContact />
                  </RouteValidate>
                }
              />

              <Route
                path="/BasicCompanyCin"
                element={
                  <RouteValidate slug="BasicCompanyCin">
                    <BasicCompanyCin />
                  </RouteValidate>
                }
              />

              <Route
                path="/BulkReportAll"
                element={
                  <RouteValidate slug="BulkReportAll">
                    <BulkReportAll />
                  </RouteValidate>
                }
              />

              {/* <Route
                path="/GstToContactReport"
                element={
                  <RouteValidate slug="GstToContactReport">
                    <GstToContactReport />
                  </RouteValidate>
                }
              /> */}

              <Route
                path="/PanToCin"
                element={
                  <RouteValidate slug="PanToCin">
                    <PanToCin />
                  </RouteValidate>
                }
              />
              <Route
                path="/EwayBillV2"
                element={
                  <RouteValidate slug="EwayBillV2">
                    <EwayBillV2 />
                  </RouteValidate>
                }
              />
              <Route
                path="/KycPanDetails"
                element={
                  <RouteValidate slug="KycPanDetails">
                    <KycPanDetails />
                  </RouteValidate>
                }
              />

              <Route
                path="/EquifaxCreditReportDashboard"
                element={
                  <RouteValidate slug={"EquifaxCreditReportDashboard"}>
                    <EquifaxCreditReportDashboard />
                  </RouteValidate>
                }
              />

              <Route
                path="/HighmarkCrScore"
                element={
                  <RouteValidate slug={"HighmarkCrScore"}>
                    <HighmarkCrScore />
                  </RouteValidate>
                }
              />
              <Route
                path="/CheckScore"
                element={
                  <RouteValidate slug={"CheckScore"}>
                    <CheckScore />
                  </RouteValidate>
                }
              />
              <Route
                path="/CheckScorePrefill"
                element={
                  <RouteValidate slug={"CheckScorePrefill"}>
                    <CheckScorePrefill />
                  </RouteValidate>
                }
              />
              <Route
                path="/ExperianScore2"
                element={
                  <RouteValidate slug={"ExperianScore2"}>
                    <ExperianScore2 />{" "}
                  </RouteValidate>
                }
              />
              <Route
                path="/ExperianScore3"
                element={
                  <RouteValidate slug={"ExperianScore3"}>
                    <ExperianScore3 />{" "}
                  </RouteValidate>
                }
              />
              <Route
                path="/CreateMobileDeviceLock"
                element={
                  <RouteValidate slug={"CreateMobileDeviceLock"}>
                    <CreateMobileDeviceLock />{" "}
                  </RouteValidate>
                }
              />
              <Route
                path="/rc-challan-details"
                element={
                  <RouteValidate slug="/rc-challan-details">
                    <RcToChallan />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/rc-premium-v2"
                element={
                  <RouteValidate slug="/rc-premium-v2">
                    <RcPremiumV2 />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/rc-to-mobile-srv2"
                element={
                  <RouteValidate slug="/rc-to-mobile-srv2">
                    <RcToMobileSrv2 />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/mobile-to-rc-srv2"
                element={
                  <RouteValidate slug="/mobile-to-rc-srv2">
                    <MobileToRcSrv2 />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/rc-pro-masked"
                element={
                  <RouteValidate slug="/rc-pro-masked">
                    <RcProMasked />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/rc-pro-unmasked"
                element={
                  <RouteValidate slug="/rc-pro-unmasked">
                    <RcProUnmasked />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/e-challan-srv2"
                element={
                  <RouteValidate slug="/e-challan-srv2">
                    <EChallanSrv2 />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/challan-pro-srv2"
                element={
                  <RouteValidate slug="/challan-pro-srv2">
                    <ChallanProSrv2 />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/engine-to-rc-srv2"
                element={
                  <RouteValidate slug="/engine-to-rc-srv2">
                    <EngineToRcSrv2 />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/rc-pro-cache"
                element={
                  <RouteValidate slug="/rc-pro-cache">
                    <RcProCache />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/aadhar-details-verification"
                element={
                  <RouteValidate slug="/aadhar-details-verification">
                    <AadharDetailsVerify />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/bank-verification/pennyDrop"
                element={
                  <RouteValidate slug="/bank-verification/pennyDrop">
                    <BankVerificationPennyDrop />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/bank-verification/bennyValidation"
                element={
                  <RouteValidate slug="/bank-verification/bennyValidation">
                    <BankBennyValidation />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/aadhar-to-pan"
                element={
                  <RouteValidate slug="/aadhar-to-pan">
                    <AadharToPanDetails />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/BusinessWalletStructure"
                element={
                  <RouteValidate slug={"BusinessWalletStructure"}>
                    <BusinessWalletStructure />
                  </RouteValidate>
                }
              />
              <Route
                path="/PayoutReport"
                element={
                  <RouteValidate slug={"BusinessWalletStructure"}>
                    {" "}
                    <PayoutReport />
                  </RouteValidate>
                }
              />
              <Route
                path="/ServicePage"
                element={
                  <RouteValidate slug={"ServicePage"}>
                    <ServicePage />
                  </RouteValidate>
                }
              />
              <Route
                path="/ApiIntegrationGuide"
                element={
                  <RouteValidate slug={"ApiIntegrationGuide"}>
                    <ApiIntegrationGuide />
                  </RouteValidate>
                }
              />
              <Route
                path="/DiscriptionLink"
                element={
                  <RouteValidate slug={"DiscriptionLink"}>
                    {" "}
                    <DiscriptionLink />
                  </RouteValidate>
                }
              />
              <Route
                path="/RechargeAndBBPSReport"
                element={
                  <RouteValidate slug={"DiscriptionLink"}>
                    <RechargeAndBBPSReport />
                  </RouteValidate>
                }
              />
              <Route
                path="/CreditScoreReport"
                element={
                  <RouteValidate slug={"EquifaxCrScorev2"}>
                    <EquifaxV2 />
                  </RouteValidate>
                }
              />
              <Route
                path="/aadhar/download"
                element={
                  <RouteValidate slug="/aadhar/download">
                    <AadharDownload />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/check-fir"
                element={
                  <RouteValidate slug="/check-fir">
                    <CheckFIR />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/e-signer"
                element={
                  <RouteValidate slug="/e-signer">
                    <ESigner />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/company-cin/verification"
                element={
                  <RouteValidate slug="/company-cin/verification">
                    <CompanyCinVerfication />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/itr/compliance-check"
                element={
                  <RouteValidate slug="/itr/compliance-check">
                    <ItrComplinceCheck />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/verify/ration-card"
                element={
                  <RouteValidate slug="/verify/ration-card">
                    <RationCardTest />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/upi-verification/advance"
                element={
                  <RouteValidate slug="/upi-verification/advance">
                    <AdvanceUpiCheck />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/MoblieUPILookUpEnhance"
                element={
                  <RouteValidate slug="/MoblieUPILookUpEnhance">
                    <MobileUPILookUpEnhance />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/bank-statement/analysis"
                element={
                  <RouteValidate slug="/bank-statement/analysis">
                    <BankAccountAnlyscis />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/upi-verification/simple"
                element={
                  <RouteValidate slug="/upi-verification/simple">
                    <SimpleUpiCheck />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>

              <Route
                path="/verify/panv2"
                element={
                  <RouteValidate slug="/verify/panv2">
                    <PanVerificationV2 />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/verify/pan-plus"
                element={
                  <RouteValidate slug="/verify/pan-plus">
                    <PanVerificationPlus />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/verify/pan-form"
                element={
                  <RouteValidate slug="/verify/pan-form">
                    <PanVerificationForm />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/verify/voterid"
                element={
                  <RouteValidate slug="/verify/voterid">
                    <VoterCardVerificationv2 />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/verify/passportv2"
                element={
                  <RouteValidate slug="/verify/passportv2">
                    <PassportCardVerificationv2 />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/verify/driving-licence"
                element={
                  <RouteValidate slug="/verify/driving-licence">
                    <DLVerficationV2 />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/verify/driving-licence-plus"
                element={
                  <RouteValidate slug="/verify/driving-licence-plus">
                    <DLVerifyPlus />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/verify/digital-kyc"
                element={
                  <RouteValidate slug="/verify/digital-kyc">
                    <AadharDigitalKyc />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/VerifyRc"
                element={
                  <RouteValidate slug={"/VerifyRc"}>
                    <VerifyRc />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/rc-premium-v3"
                element={
                  <RouteValidate slug={"/rc-premium-v3"}>
                    <RcPremiumV3 />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/rc-premium-v4"
                element={
                  <RouteValidate slug={"/rc-premium-v4"}>
                    <RcPremiumV4 />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/verify/rc-reverse-details"
                element={
                  <RouteValidate slug={"/verify/rc-reverse-details"}>
                    <VerifyRcReverse />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/verify/VerifyRcPlus"
                element={
                  <RouteValidate slug={"/verify/VerifyRcPlus"}>
                    <VerifyRcPlus />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/facedetection"
                element={
                  <RouteValidate slug="/facedetection">
                    <FaceDetection />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/pandetailsV1"
                element={
                  <RouteValidate slug="/pandetailsV1">
                    <PanDetailsV1 />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/pantofatherdetails"
                element={
                  <RouteValidate slug="/pantofatherdetails">
                    <PanToFatherDetails />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/panbasic"
                element={
                  <RouteValidate slug="/panbasic">
                    <PanBasic />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/pandetailsV2"
                element={
                  <RouteValidate slug="/pandetailsV2">
                    <PanDetailsV2 />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/panprofile"
                element={
                  <RouteValidate slug="/panprofile">
                    <PanProfile />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/udyambasic"
                element={
                  <RouteValidate slug="/udyambasic">
                    <UdyamBasic />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/mobile-to-udyam-lookup"
                element={
                  <RouteValidate slug="/mobile-to-udyam-lookup">
                    <MobileToUdyamLookup />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/udyam-advance"
                element={
                  <RouteValidate slug="/udyam-advance">
                    <UdyamAdvance />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/RCToMobile"
                element={
                  <RouteValidate slug="/RCToMobile">
                    <RcToMobile />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/rc-verification"
                element={
                  <RouteValidate slug="/rc-verification">
                    <RcVerification />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/rc/advance-verification"
                slug="/rc/advance-verification"
                element={
                  <RouteValidate>
                    <RcVerificationAdvance />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/bank-verification/penny-drop-advance"
                slug="/bank-verification/penny-drop-advance"
                element={
                  <RouteValidate>
                    <BankVerificationPennyDropAdvance />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/bank-verification/penny-less-advance"
                slug="/bank-verification/penny-less-advance"
                element={
                  <RouteValidate>
                    <BankBennyValidationAdvance />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/ifsc-verify"
                slug="/ifsc-verify"
                element={
                  <RouteValidate>
                    <IFSCVerify />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/din-to-pan"
                slug="/din-to-pan"
                element={
                  <RouteValidate>
                    <DinToPan />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/pan-to-din"
                slug="/pan-to-din"
                element={
                  <RouteValidate>
                    <PanToDin />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/gst-pan-search"
                slug="/gst-pan-search"
                element={
                  <RouteValidate>
                    <GstPanSearch />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/digilocker/digital-kyc"
                slug="/digilocker/digital-kyc"
                element={
                  <RouteValidate>
                    <DigitalKyc />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/digilocker-result-page"
                slug="/digilocker-result-page"
                element={
                  <RouteValidate>
                    <DigilockerResultPage />
                  </RouteValidate>
                }
              ></Route>

              <Route
                path="/dintocontact2"
                element={
                  <RouteValidate slug="/dintocontact2">
                    <DinToContact2 />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/verifyConsumerDetails"
                element={
                  <RouteValidate slug="/verifyConsumerDetails">
                    <VerifyConsumerDetails />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/prefill"
                element={
                  <RouteValidate slug="/prefill">
                    <Prefill />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/prefillv2"
                element={
                  <RouteValidate slug="/prefillv2">
                    <Prefillv2 />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/prefillv3"
                element={
                  <RouteValidate slug="/prefillv3">
                    <Prefillv3 />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/prefillv4"
                element={
                  <RouteValidate slug="/prefillv4">
                    <Prefillv4 />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/rcCard"
                element={
                  <RouteValidate slug="/rcCard">
                    <RcCardDetails />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/ProfileFetch"
                element={
                  <RouteValidate slug="/ProfileFetch">
                    <ProfileFetch />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/ProfileFetchV2"
                element={
                  <RouteValidate slug="/ProfileFetchV2">
                    <ProfileFetchV2 />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/MobileToUpiAdvanceSrv2"
                element={
                  <RouteValidate slug="/MobileToUpiAdvanceSrv2">
                    <MobileToUpiAdvanceSrv2 />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/OcrVoter"
                element={
                  <RouteValidate slug="/OcrVoter">
                    <OcrVoter />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/OcrPassport"
                element={
                  <RouteValidate slug="/OcrPassport">
                    <OcrPassport />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/OcrDl"
                element={
                  <RouteValidate slug="/OcrDl">
                    <OcrDl />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/OcrGenericKyc"
                element={
                  <RouteValidate slug="/OcrGenericKyc">
                    <OcrGenericKyc />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/DrivingLicence"
                element={
                  <RouteValidate slug="/DrivingLicence">
                    <DrivingLicence />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/RcVerificationFull"
                element={
                  <RouteValidate slug="/RcVerificationFull">
                    <RcVerificationFull />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/UpiBasicV2"
                element={
                  <RouteValidate slug="/UpiBasicV2">
                    <UpiBasicV2 />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/UpiVerificationAdvance"
                element={
                  <RouteValidate slug="/UpiVerificationAdvance">
                    <UpiVerificationAdvance />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/UpiVerificationSimple"
                element={
                  <RouteValidate slug="/UpiVerificationSimple">
                    <UpiVerificationSimple />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/PanToContact"
                element={
                  <RouteValidate slug="/PanToContact">
                    <PanToContact />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>
              <Route
                path="/PanToBankAccount"
                element={
                  <RouteValidate slug="/PanToBankAccount">
                    <PanToBankAccount />
                  </RouteValidate>
                }
              >
                {" "}
              </Route>

              <Route
                path="/mandate"
                element={
                  <RouteValidate slug={"/mandate"}>
                    <Mandate />
                  </RouteValidate>
                }
              ></Route>

              <Route
                path="/AppDownload"
                element={
                  <RouteValidate slug={"AppDownload"}>
                    <AppDownload />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/verify/basics/gst"
                element={
                  <RouteValidate slug={"/verify/basics/gst"}>
                    <VerifyKybBasic />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/verify/advance/gst"
                element={
                  <RouteValidate slug={"/verify/advance/gst"}>
                    <VerifyKybAdvancedGST />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/verify/contact-to-gst"
                element={
                  <RouteValidate slug={"/verify/contact-to-gst"}>
                    <VerifyKybContactToGST />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/verify/gst-to-contact"
                element={
                  <RouteValidate slug={"/verify/gst-to-contact"}>
                    <VerifyKybGSTToContact />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/ovse"
                element={
                  <RouteValidate slug={"/ovse"}>
                    <Ovse />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/payout/single"
                element={
                  <RouteValidate slug={"/payout/single"}>
                    <SinglePayout />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/payout/manage-beneficiary"
                element={
                  <RouteValidate slug={"/payout/manage-beneficiary"}>
                    <ManageBenificiary />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/payout/bulk"
                element={
                  <RouteValidate slug={"/payout/bulk"}>
                    <BulkPayout />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/payout/report"
                element={
                  <RouteValidate slug={"/payout/report"}>
                    <PayoutAllReport />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/ChallanPro"
                element={
                  <RouteValidate slug={"/ChallanPro"}>
                    <ChallanPro />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/FastagBalance"
                element={
                  <RouteValidate slug={"/FastagBalance"}>
                    <FastagBalance />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/RcPro"
                element={
                  <RouteValidate slug={"/RcPro"}>
                    <RcPro />
                  </RouteValidate>
                }
              ></Route>

              <Route
                path="/BulkRcToMobile"
                element={
                  <RouteValidate slug={"/BulkRcToMobile"}>
                    <BulkRcToMobile />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/ChasisToRc"
                element={
                  <RouteValidate slug={"/ChasisToRc"}>
                    <ChasisToRc />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/ChasisToRcV2"
                element={
                  <RouteValidate slug={"/ChasisToRcV2"}>
                    <ChasisToRcV2 />
                  </RouteValidate>
                }
              ></Route>
              
              <Route
                path="/chassis-to-rc-srv2"
                element={
                  <RouteValidate slug={"/chassis-to-rc-srv2"}>
                    <ChassisToRcSrv2 />
                  </RouteValidate>
                }
              ></Route>

              <Route
                path="/vehicle-insurance-srv2"
                element={
                  <RouteValidate slug={"/vehicle-insurance-srv2"}>
                    <VehicleInsurance />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/vehicle-fop-details"
                element={
                  <RouteValidate slug={"/vehicle-fop-details"}>
                    <VehicleFopDetails />
                  </RouteValidate>
                }
              ></Route>

              <Route
                path="/FastagTxn"
                element={
                  <RouteValidate slug={"/FastagTxn"}>
                    <FastagTxn />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/MobileToRc"
                element={
                  <RouteValidate slug={"/MobileToRc"}>
                    <MobileToRC />
                  </RouteValidate>
                }
              ></Route>

              <Route
                path="/RcToMobileSrv1"
                element={
                  <RouteValidate slug={"/RcToMobileSrv1"}>
                    <RcToMobileSrv1 />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/VehicleValuationPro"
                element={
                  <RouteValidate slug={"/VehicleValuationPro"}>
                    <VehicleValuationPro />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/VehicleRcLite"
                element={
                  <RouteValidate slug={"/VehicleRcLite"}>
                    <VehicleRcLite />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/EngineToRc"
                element={
                  <RouteValidate slug={"/EngineToRc"}>
                    <EngineToRc />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/VehicleRcLogs"
                element={
                  <RouteValidate slug={"/VehicleRcLogs"}>
                    <VehicleRcLogs />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/ChallanProImage"
                element={
                  <RouteValidate slug={"/ChallanProImage"}>
                    <ChallanProImage />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/VehicleServiceHistory"
                element={
                  <RouteValidate slug={"/VehicleServiceHistory"}>
                    <VehicleServiceHistory />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/VehiclePuccPro"
                element={
                  <RouteValidate slug={"/VehiclePuccPro"}>
                    <VehiclePuccPro />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/VehicleExShowroom"
                element={
                  <RouteValidate slug={"/VehicleExShowroom"}>
                    <VehicleExShowroom />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/VehicleInsurancePro"
                element={
                  <RouteValidate slug={"/VehicleInsurancePro"}>
                    <VehicleInsurancePro />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/FastagStatus"
                element={
                  <RouteValidate slug={"/FastagStatus"}>
                    <FastagStatus />
                  </RouteValidate>
                }
              ></Route>

              <Route
                path="/VehicleFastagMapper"
                element={
                  <RouteValidate slug={"/VehicleFastagMapper"}>
                    <VehicleFastagMapper />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/DlLicence"
                element={
                  <RouteValidate slug={"/DlLicence"}>
                    <DlLicence />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/BasicEChallan"
                element={
                  <RouteValidate slug={"/BasicEChallan"}>
                    <BasicEChallan />
                  </RouteValidate>
                }
              ></Route>

              <Route
                path="/UanMobile"
                element={
                  <RouteValidate slug={"/UanMobile"}>
                    <UanMobile />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/UanMobileSrv3"
                element={
                  <RouteValidate slug={"/UanMobileSrv3"}>
                    <UanMobileSrv3 />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/UanNameDob"
                element={
                  <RouteValidate slug={"/UanNameDob"}>
                    <UanNameDob />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/UanDirect"
                element={
                  <RouteValidate slug={"/UanDirect"}>
                    <UanDirect />
                  </RouteValidate>
                }
              ></Route>

              <Route
                path="/UanDirectSrv3"
                element={
                  <RouteValidate slug={"/UanDirectSrv3"}>
                    <UanDirectSrv3 />
                  </RouteValidate>
                }
              ></Route>

              <Route
                path="/UanPan"
                element={
                  <RouteValidate slug={"/UanPan"}>
                    <UanPan />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/AadhaarToUnmaskedPan"
                element={
                  <RouteValidate slug={"/AadhaarToUnmaskedPan"}>
                    <AadhaarToUnmaskedPan />
                  </RouteValidate>
                }
              ></Route>
              <Route
                path="/VerifyGstBasic"
                element={
                  <RouteValidate slug={"/VerifyGstBasic"}>
                    <VerifyGstBasic />
                  </RouteValidate>
                }
              ></Route>

              <Route
                path="/mobile-to-account-srv2"
                element={
                  <RouteValidate slug={"/mobile-to-account-srv2"}>
                    <MobileToAccountSrv2 />
                  </RouteValidate>
                }
              ></Route>

              <Route
                path="/bank-account-aggregator"
                element={
                  <RouteValidate slug={"/bank-account-aggregator"}>
                    <BankAccountAggregator />
                  </RouteValidate>
                }
              ></Route>

              <Route
                path="/UanPanMobilesrv3"
                element={
                  <RouteValidate slug={"/UanPanMobilesrv3"}>
                    <UanPanMobileSrv3 />
                  </RouteValidate>
                }
              ></Route>
              <Route path="/LockScreen" element={<LockScreen />} />

              <Route path="/RouteValidate" element={<RouteValidate />} />
            </Route>

            <Route
              path="/CompleteProfile"
              element={
                <AuthWrapper noLayout>
                  <RouteValidate slug="CompleteProfile">
                    <CompleteProfile />
                  </RouteValidate>
                </AuthWrapper>
              }
            />
            <Route path="/Session-expired" element={<SessionExpired />} />
          </Routes>
        </ServiceProvider>
      </RoutesWrapper>
    </Router>
  );
}

function RoutesWrapper({ children }) {
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000); // 2 seconds

    return () => clearTimeout(timer);
  }, [location]);

  return (
    <>
      {loading && <Loader />}
      {children}
    </>
  );
}

export default App;
